import { ActivatedRouteSnapshot } from '@angular/router';

const getPath = (route: ActivatedRouteSnapshot) => {
  let path: string[] = route.url.map(u => u.path);
  if (!path.length && route.routeConfig?.path) {
    const configPath = route.routeConfig.path;
    if (!configPath.includes(':') && !configPath.includes('**')) {
      path = [route.routeConfig.path];
    }
  }
  if (route.firstChild) {
    const childPath = getPath(route.firstChild);
    if (childPath) path = path.concat(...childPath);
  }
  return path;
};

export const getFullPath = (route: ActivatedRouteSnapshot, removePageParam = true) => {
  const path = getPath(route.root);
  // remove last segment if it matches page-{number}
  if (removePageParam) {
    const last = path[path.length - 1];
    if (last && last.match(/^page-\d+$/)) {
      path.pop();
    }
  }

  return path;
};
